import { createAsyncThunk } from '@reduxjs/toolkit';
import notify from '../../utils/notify';

//Include Both Helper File with needed methods
import {
  getProjectList as getProjectListApi,
  addProjectList as addProjectListApi,
  updateProjectList as updateProjectListApi,
  deleteProjectList as deleteProjectListApi,
} from '../../helpers/fakebackend_helper';

export const getProjectList = createAsyncThunk(
  'projects/getProjectList',
  async () => {
    try {
      const response = getProjectListApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const addProjectList = createAsyncThunk(
  'projects/addProjectList',
  async project => {
    try {
      const response = addProjectListApi(project);
      const data = await response;
      notify.success('project-list added successfully.');
      return data;
    } catch (error) {
      notify.apiError(error, 'add project-list');
      return error;
    }
  }
);

export const updateProjectList = createAsyncThunk(
  'projects/updateProjectList',
  async project => {
    try {
      const response = updateProjectListApi(project);
      const data = await response;
      notify.success('project-list updated successfully.');
      return data;
    } catch (error) {
      notify.apiError(error, 'update project-list');
      return error;
    }
  }
);

export const deleteProjectList = createAsyncThunk(
  'projects/deleteProjectList',
  async data => {
    try {
      const response = deleteProjectListApi(data);
      const newdata = await response;
      notify.success('project-list deleted successfully.');
      return newdata;
    } catch (error) {
      notify.apiError(error, 'delete project-list');
      return error;
    }
  }
);
